<template>
    <div class="bg-white">
        <feedback-component
            :account-id="account.id"
            :email="account.contact.email"
            :consumer-portal-data="consumerPortalData"
            :redirect="consumerPortalData.consumerPortalBaseUrl"
            :referral="referral"
        />

        <div class="p-5 mx-auto md:w-2/3 lg:w-1/2 xl:w-1/3 2xl:w-1/4">
            <div class="group block">
                <p class="font-medium text-sm text-center">
                    If you have any questions, please feel free to reach us at <a :href="`tel:${$root.phoneNumberForLocation('footer')}`" style="white-space: nowrap;">{{ $root.phoneNumberForLocation('footer') }}</a>.
                </p>
            </div>
        </div>
    </div>
</template>

<script>
    import FeedbackComponent from '../components/FeedbackComponent';

    export default {
        props: {
            account: {},
            referral: {},
            consumerPortalData: {}
        },

        components: {
            FeedbackComponent
        }
    }
</script>
